import createStore from "astrid-helpers/src/createStore";
export const [getLocked, setLocked, useLocked] = createStore();
//# sourceMappingURL=locked.js.map